"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledSvg = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _lodash = require("lodash");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } /* External dependencies */
/**
 * Styled SVG Component.
 *
 * @param {Object} props The component's props.
 *
 * @returns {React.Element} StyledSvg component.
 */
const StyledSvg = exports.StyledSvg = _styledComponents.default.svg`
	width: ${props => props.size};
	height: ${props => props.size};
	flex: none;
`;

/**
 * Returns the SvgIconSet component.
 *
 * @param {object} props Component props.
 *
 * @returns {React.Element} SvgIconSet component.
 */
class SvgIconSet extends _react.default.Component {
  /**
   * Renders an SVG icon.
   *
   * @returns {React.Element|null} The rendered SVG icon.
   */
  render() {
    const {
      iconSet,
      icon,
      className,
      color,
      size
    } = this.props;
    const iconName = iconSet[icon];
    if (!iconName) {
      console.warn(`Invalid icon name ("${icon}") passed to the SvgIcon component.`);
      return null;
    }
    const path = iconName.path;
    const viewbox = iconName.viewbox;
    const iconClass = ["yoast-svg-icon", "yoast-svg-icon-" + icon, className].filter(Boolean).join(" ");
    const ComponentToUse = iconName.CustomComponent ? iconName.CustomComponent : StyledSvg;
    return /*#__PURE__*/_react.default.createElement(ComponentToUse, {
      "aria-hidden": true,
      role: "img",
      focusable: "false",
      size: size,
      className: iconClass,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: viewbox,
      fill: color
    }, (0, _lodash.isArray)(path) ? path : /*#__PURE__*/_react.default.createElement("path", {
      d: path
    }));
  }
}
SvgIconSet.propTypes = {
  icon: _propTypes.default.string.isRequired,
  iconSet: _propTypes.default.object.isRequired,
  color: _propTypes.default.string,
  size: _propTypes.default.string,
  className: _propTypes.default.string
};
SvgIconSet.defaultProps = {
  size: "16px",
  color: "currentColor",
  className: ""
};

/**
 * Create an SVG Icon component with a custom set of icons.
 *
 * @param {Object} iconSet Set of SVG icons.
 *
 * @returns {React.Component} The SvgIcon component.
 */
var _default = iconSet => {
  /**
   * Renders an SVG icon.
   *
   * @param {object} props The component props.
   *
   * @returns {React.Element} The react element.
   */
  const SvgIcon = props => {
    return /*#__PURE__*/_react.default.createElement(SvgIconSet, _extends({}, props, {
      iconSet: iconSet
    }));
  };
  SvgIcon.propTypes = {
    icon: _propTypes.default.string.isRequired,
    color: _propTypes.default.string,
    size: _propTypes.default.string,
    className: _propTypes.default.string
  };
  SvgIcon.defaultProps = {
    size: "16px",
    color: "currentColor",
    className: ""
  };
  return SvgIcon;
};
exports.default = _default;